/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_OrInputs */

const en_signin_or = /** @type {(inputs: Signin_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or`)
};

const id_signin_or = /** @type {(inputs: Signin_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atau`)
};

/**
* | output |
* | --- |
* | "or" |
*
* @param {Signin_OrInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_or = /** @type {((inputs?: Signin_OrInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_OrInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_or(inputs)
	return en_signin_or(inputs)
});